// extracted by css-extract-rspack-plugin
module.exports =  {"template-16":"Template16-JW89__template-16","button":"Template16-Z4wf__button","sentence":"Template16-iq3M__sentence","options":"Template16-Ay0i__options"};